import { observer } from 'mobx-react-lite';
import { Segment, List, Label, Item, Icon, Grid } from 'semantic-ui-react';
import MyAddUser from '../../../app/common/adduser/MyAddUser';
import { useStore } from '../../../app/stores/store';
import { useEffect } from 'react';
import '../../../app/common/MediaQuery/responsive-view-page.css';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import ImageTag from '../../../features/Profile/RenderImage';
import { assignUserType } from '../../../app/api/types';

function ActivityUser() {
  const {
    userStore: { user },
    activityStore: {
      selectedActivity: activity,
      loadMovementHistory,
      loadTimeDiff,
    },
    commonStore,
    viewStore: {
      assignedUsers,
      removeUserFromItem,
      getAssignedUsers,
      getUnAssignedUsers,
    },
    RolesAndPermissionsStore: { rolesRegistry, loadRoles },
  } = useStore();

  useEffect(() => {
    if (rolesRegistry.size === 0) {
      loadRoles();
    }
    // eslint-disable-next-line
  }, [rolesRegistry.size]);

  const removeAssign = async (attendeeData: assignUserType) => {
    await removeUserFromItem(
      { itemId: activity?.id, userId: attendeeData.id },
      attendeeData.displayname,
    );
    await getAssignedUsers({ itemId: activity?.id });
    await getUnAssignedUsers({
      itemId: activity?.id,
      displayName: '',
      pageNo: 1,
      pageSize: 5,
    });
    loadMovementHistory(attendeeData?.id);
    loadTimeDiff(attendeeData?.id);
  };

  return (
    <div
      className={
        commonStore.filterModeZero?.includes('AVLAVD02')
          ? 'component-isDisabled small-screen-adduser'
          : 'small-screen-adduser'
      }
    >
      <Segment
        className="tablet-view"
        textAlign="center"
        attached="top"
        secondary
        inverted
        color="blue"
      >
        {assignedUsers?.length}{' '}
        {assignedUsers?.length === 1
          ? (
              userLanguage[0].AssetsViewItemLevelViewPageUsersAssignedSegment
                ?.AVILVPUASL01A1 as any
            )?.[`${commonStore.language.key}`]
          : (
              userLanguage[0].AssetsViewItemLevelViewPageUsersAssignedSegment
                ?.AVILVPUASL01A2 as any
            )?.[`${commonStore.language.key}`]}{' '}
        {
          (
            userLanguage[0].AssetsViewItemLevelViewPageUsersAssignedSegment
              ?.AVILVPUASL01B as any
          )?.[`${commonStore.language.key}`]
        }
      </Segment>
      <Segment className="assign-user-segment">
        <Segment attached className="tablet-view-search">
          <List relaxed divided>
            {assignedUsers?.map((attendee) => (
              <Item
                style={{
                  position: 'relative',
                  marginBottom: '10px',
                  height: '90px',
                }}
                key={attendee?.displayname}
              >
                <Label
                  style={{ position: 'absolute' }}
                  color="blue"
                  ribbon="right"
                >
                  {attendee.roleName}
                </Label>
                <ImageTag
                  imageUrl={attendee?.image}
                  defaultUrl="/assets/user.png"
                  size="mini"
                />
                <Item.Content verticalAlign="middle">
                  <Item.Header as="h3">
                    <List.Header style={{ color: '#4183c4' }}>
                      {attendee?.displayname}
                    </List.Header>
                    {attendee?.displayname === user?.displayName ||
                    commonStore.filterModeTwo?.includes('AVLAVB10') ? null : (
                      <Label
                        attached="bottom right"
                        onClick={() => {
                          removeAssign(attendee);
                        }}
                        className={
                          commonStore.filterModeZero?.includes('AVLAVB10')
                            ? 'component-isDisabled'
                            : ''
                        }
                      >
                        <Icon name="close" />
                      </Label>
                    )}
                  </Item.Header>
                  <Item.Extra
                    style={{ color: 'orange' }}
                    //Assigned
                  >
                    {
                      (
                        userLanguage[0]
                          .AssetsViewItemLevelViewPageUsersAssignedSegment
                          ?.AVILVPUASL02 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </Item.Extra>
                </Item.Content>
              </Item>
            ))}
            <Grid></Grid>
          </List>
        </Segment>
        <Segment attached className="tablet-activity-user">
          <MyAddUser />
        </Segment>
      </Segment>
    </div>
  );
}

export default observer(ActivityUser);
